import React from "react";
import { useRef, useState } from "react";
import { Dialog } from "primereact/dialog";
import { InputNumber } from "primereact/inputnumber";
import StopWatch from "./StopWatch";

export default function EditScoresDialog({
  results,
  selectedSport,
  visible,
  onHide,
  onChange,
  round,
  participantToEdit,
  setParticipantToEdit
}) {
  const inputRef = useRef(null);

  const sport = results.sports[selectedSport];
  const participant = results.participants[participantToEdit];
  if (!participant) return null; // guard if participantToEdit is out of bounds

  const score = sport.results.find((r) => r.id === participant.id)?.results[round] ?? 0;

  const updateScore = (participantId, value) => {
    let resultEntry = sport.results.find((r) => r.id === participantId);
    if (!resultEntry) {
      resultEntry = { id: participantId, results: Array(sport.rounds).fill(0) };
      sport.results.push(resultEntry);
    }
    resultEntry.results[round] = value ?? 0;

    const newResults = {
      ...results,
      sports: results.sports.map((s, idx) => (idx === selectedSport ? sport : s)),
    };

    onChange(newResults);
  };

  return (
    <Dialog
      header={`Kierros ${round + 1}`}
      visible={visible}
      onHide={onHide}
      style={{ width: "420px" }}
      onShow={() => {
        // Called after the dialog is in the DOM
        inputRef.current?.focus();
      }}
      dismissableMask
    >
      <div style={{ textAlign: "center", marginBottom: "1rem" }}>
        <h3>{participant.name || "Unknown"}</h3>

        {!sport.time ? (
          <InputNumber
            value={score}
            mode="decimal"
            ref={inputRef}
            min={0}
            onFocus={(e) => e.target.select()}
            inputStyle={{ width: "3rem", textAlign: "center" }}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                const numericValue = Number(inputRef.current.getInput().value);
                updateScore(participant.id, numericValue)
                setTimeout(() => {
                  const inputEl = inputRef.current.getInput();
                  inputEl.focus();
                  inputEl.select(); // explicitly select the text
                }, 500);
                
                setTimeout(() => {
                  setParticipantToEdit((participantToEdit + 1) % results.participants.length); 
                }, 200);
              }
            }}
          />
        ) : (
          <StopWatch onUpdate={(time) => updateScore(participant.id, time)} result={score} />
        )}
      </div>
    </Dialog>
  );
}
